/**
 * Header offset
 *
 * The site header is `position: fixed` at desktop widths, so it sits outside the
 * document flow and would overlap the top of the page content. Rather than
 * hard-coding a magic number (the header height changes with the optional utility
 * bar and across breakpoints), measure the real header and publish it as a CSS
 * custom property:
 *
 *     :root { --header-height: 135px; }
 *
 * `src/less/layout/header.less` consumes that variable to offset `.site-content`,
 * and ships a static fallback so the layout is still correct before this runs.
 */

var HEADER_SELECTOR = '.header';
var CSS_VAR = '--header-height';

function measureHeader() {
    var header = document.querySelector(HEADER_SELECTOR);

    if (!header) {
        return;
    }

    // Only offset while the header is actually taken out of the flow. At mobile
    // widths it is `position: relative` and already occupies its own space.
    var isFixed = window.getComputedStyle(header).position === 'fixed';
    var height = isFixed ? header.offsetHeight : 0;

    document.documentElement.style.setProperty(CSS_VAR, height + 'px');
}

function initHeaderOffset() {
    measureHeader();

    // Re-measure when the header's height can change.
    if ('ResizeObserver' in window) {
        var header = document.querySelector(HEADER_SELECTOR);

        if (header) {
            new ResizeObserver(measureHeader).observe(header);
        }
    } else {
        window.addEventListener('resize', measureHeader);
    }

    // Webfonts can reflow the header after first paint.
    if (document.fonts && document.fonts.ready) {
        document.fonts.ready.then(measureHeader);
    }
}

document.addEventListener('DOMContentLoaded', initHeaderOffset);

export { initHeaderOffset, measureHeader };
